import { render, staticRenderFns } from "./mode.vue?vue&type=template&id=38f2c40b&scoped=true"
import script from "./mode.vue?vue&type=script&lang=ts"
export * from "./mode.vue?vue&type=script&lang=ts"
import style0 from "./mode.vue?vue&type=style&index=0&id=38f2c40b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f2c40b",
  null
  
)

export default component.exports